import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router';

import { Icon } from '@/components/ui/Icon';
import type { NavSection } from '@/layouts/navigation';
import clsx from '@/utils/clsx';
import { env } from '@/utils/env';

import styles from './AppLayout.module.css';

interface MobileNavProps {
  id: string;
  show: boolean;
  onHide: () => void;
  sections: NavSection[];
  activeTarget: string | null;
}

/** Below lg: every section, grouped, in a drawer opened from the navbar's menu button. */
export function MobileNav({ id, show, onHide, sections, activeTarget }: MobileNavProps) {
  return (
    <Offcanvas id={id} show={show} onHide={onHide} placement="end" aria-label="Main navigation">
      <Offcanvas.Header closeButton closeLabel="Close navigation menu">
        <Offcanvas.Title as="h2" className="fs-5">
          {env.appName}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <nav aria-label="Main" className={styles.mobileNav}>
          {sections.map((section) => (
            <div key={section.id}>
              {section.title && <p className={styles.mobileNavTitle}>{section.title}</p>}
              <ul className={styles.mobileNavList}>
                {section.items.map((item) => {
                  const isActive = item.to === activeTarget;
                  return (
                    <li key={item.to}>
                      <Link
                        to={item.to}
                        onClick={onHide}
                        className={clsx(styles.mobileNavLink, isActive && styles.topNavActive)}
                        aria-current={isActive ? 'page' : undefined}
                      >
                        <Icon name={item.icon} />
                        {item.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
